<template>
    <div
        id="datepicker-trigger"
        class="date-filter-root clickable root noselect "
    >
        <div @click="open" class="d-inline-flex align-content-center">
            <div
                class="caption muted mb-0 secondary-color"
                style="line-height: normal; align-self: end; font-size: 15px;"
            >
                {{ label }}
            </div>
            <b-badge
                v-if="date"
                class="secondary-color light-gray lighten-background align-self-center ml-1"
                >{{ formattedDate() }}</b-badge
            >
            <BaseIcon class="secondary-color" name="caret-down" size="xs" />
        </div>
        <div class="date-picker-wrapper">
            <YearMonthPicker
                hideInput
                anchor="top"
                mobileAnchor="bottom"
                :open="showPicker"
                :value="date"
                @input="onDateChange"
                @close="onClose"
            />
        </div>
    </div>
</template>

<script>
import moment from 'moment';
export default {
    name: 'DateFilter',
    props: {
        label: String,
        value: Object,
        filterLabel: String,
    },
    data: () => ({
        date: '',
        showPicker: false,
    }),
    methods: {
        open() {
            this.showPicker = true; // !this.showPicker;
        },
        onClose() {
            this.showPicker = false;
        },
        onDateChange(newDate) {
            this.date = newDate;
            this.emit(newDate);
        },
        emit(newDate) {
            // Inserting the selected date to the filters in the form of milliseconds since 1970.
            const dateObject = new Date(newDate);
            const filters = Object.assign({}, this.value);
            filters[this.filterLabel] = dateObject.getTime();
            this.$emit('update:filter', { ...filters });
        },
        formattedDate() {
            return moment(this.date).format('MMM YY');
        },
    },
    watch: {
        value(value) {
            if (value && value[this.filterLabel]) {
                const currentDate = new Date(this.date);
                const incomingDate = new Date(value[this.filterLabel]);

                // Only update if they are not equal
                if (currentDate.toISOString() !== incomingDate.toISOString()) {
                    this.date = incomingDate;
                }
            } else {
                this.date = '';
            }
        },
    },
};
</script>

<style scoped>
.date-filter-root {
    position: relative;
}

.date-picker {
    left: 0 !important;
    border-width: 0px;
    box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15) !important;
    border-radius: var(--border-radius);
}

@media only screen and (max-width: 600px) {
    .date-filter-root {
        position: static;
    }
}
</style>
